import { Select, SelectProps, Stack } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { useFormInputs } from 'pages/revisions-module/template-editor/editors/form/input/FormInputsDataProvider';
import { IFormInputContext, IFormInputSpec } from 'pages/revisions-module/template-editor/editors/form/types';
import { useMemo } from 'react';

interface IfElseInputPropertiesSubFormProps {
  form: UseFormReturnType<IFormInputSpec>;
  context: IFormInputContext;
}

/**
 * Property editor for the if/else input type.
 */
export default function IfElseInputPropertiesSubForm({ form, context }: IfElseInputPropertiesSubFormProps) {
  const { allInputs } = useFormInputs();

  const inputOptions = useMemo(
    () =>
      allInputs
        .filter((input) => input.context === context && input.spec.name !== form.values.name)
        .map(({ spec }) => ({ value: spec.name, label: spec.label })),
    [allInputs, context, form.values.name]
  );

  const placeholder = inputOptions.length === 0 ? 'Najprv vytvorte iné pole v tejto sekcii' : undefined;
  const disabled = inputOptions.length === 0;

  const sharedProps: SelectProps = {
    required: true,
    placeholder,
    searchable: true,
    data: inputOptions,
    nothingFound: 'Žiadne pole',
    disabled,
  };

  return (
    <Stack spacing={12}>
      <Select required label="Zdrojové pole" {...sharedProps} {...form.getInputProps('fieldSource')} />
      <Select required label="Pole pre TRUE" {...sharedProps} {...form.getInputProps('fieldTrue')} />
      <Select required label="Pole pre FALSE" {...sharedProps} {...form.getInputProps('fieldFalse')} />
    </Stack>
  );
}
